import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import darkTheme from '@alfalab/core-components/themes/dark';
import mobileTheme from '@alfalab/core-components/themes/mobile';
import { useVoipContext } from '../../hooks/use-voip-context';
import { useWidgetContext } from '../../hooks/use-widget-context';
import styles from './index.module.css';
export const WebviewLayout = ({ children }) => {
    const { theme } = useWidgetContext();
    const { remoteAudioVideo } = useVoipContext();
    return (_jsxs(React.Fragment, { children: [_jsx("style", { children: mobileTheme }), theme === 'dark' && _jsx("style", { children: darkTheme }), _jsx("div", { className: cn(styles.sidePanelWrapper, styles[theme]), "data-test-id": 'voip-side-panel-webview', children: children }), _jsx("audio", { ref: remoteAudioVideo, autoPlay: true })] }));
};
